// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"styles_listContainer__ouqQ8","listTitle":"styles_listTitle__1GoNx","listItems":"styles_listItems__2EzmA","vertical":"styles_vertical__14uPY"};